import React from "react";

const SOCIALS = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61570872987221",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
        <path d="M13.5 21v-7.5h2.5l.5-3.5h-3v-2c0-1 .3-1.7 1.8-1.7H16.7V3.2C16.3 3.1 15 3 13.6 3 10.8 3 9 4.7 9 7.7v2.3H6.5v3.5H9V21h4.5z" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@RevivalFireMinistries7",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
        <path d="M23 7.2s-.2-1.6-.9-2.3c-.8-.9-1.8-.9-2.2-1C16.8 3.6 12 3.6 12 3.6s-4.8 0-7.9.3c-.4 0-1.4 0-2.2 1C1.2 5.6 1 7.2 1 7.2S.8 9 .8 10.9v1.8C.8 14.5 1 16.4 1 16.4s.2 1.6.9 2.3c.8.9 2 .9 2.5 1 1.8.2 7.6.3 7.6.3s4.8 0 7.9-.3c.4 0 1.4 0 2.2-1 .7-.7.9-2.3.9-2.3s.2-1.8.2-3.7v-1.8c0-1.9-.2-3.7-.2-3.7zM9.8 14.4V7.9l6.2 3.3-6.2 3.2z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@revivalfireministries7",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" aria-hidden="true">
        <path d="M19.6 7.3a6 6 0 0 1-3.7-1.3 6 6 0 0 1-2.2-3.5h-3v13.1a2.7 2.7 0 1 1-2.7-2.7c.3 0 .6 0 .8.1V9.9a5.7 5.7 0 1 0 5 5.7V8.7a9 9 0 0 0 5.8 2v-3.4z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/revivalfireministries/",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" className="h-5 w-5" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
      </svg>
    ),
  },
];

/**
 * Premium "Follow Revival Fire Ministries Global" section.
 * Compact: pass `variant="compact"` to render as a tight icon strip (for footers).
 * Default renders the full bento-style card with heading + copy.
 */
const SocialFollow = ({ variant = "full" }) => {
  if (variant === "compact") {
    return (
      <div className="flex items-center gap-2.5" data-testid="social-follow-compact">
        {SOCIALS.map((s) => (
          <a
            key={s.name}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Follow Revival Fire Ministries Global on ${s.name}`}
            data-testid={`social-${s.name.toLowerCase()}`}
            className="group h-10 w-10 rounded-full flex items-center justify-center text-[#C9A44C] bg-white/5 border border-[#C9A44C]/25 hover:bg-[#C9A44C]/15 hover:-translate-y-0.5 hover:text-[#F6E4B0] transition-all duration-300"
          >
            {s.icon}
          </a>
        ))}
      </div>
    );
  }

  return (
    <section className="relative py-20 px-6" data-testid="social-follow">
      <div className="max-w-5xl mx-auto bento-card !p-10 sm:!p-14 text-center">
        <span className="glow-blob" />
        <div className="overline mb-4">Connect with the fire</div>
        <h2 className="font-serif-display text-3xl sm:text-4xl text-[#F6F0E6]">
          Follow <span className="italic gold-text">Revival Fire Ministries Global</span>
        </h2>
        <p className="mt-4 text-[#D9D9D9] max-w-2xl mx-auto">
          Stay connected for prayer, prophetic teaching, service recordings, revival
          updates, and ministry moments. Every platform · one fire.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          {SOCIALS.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Follow Revival Fire Ministries Global on ${s.name}`}
              data-testid={`social-${s.name.toLowerCase()}-full`}
              className="group inline-flex items-center gap-2.5 px-5 py-3 rounded-full bg-white/5 border border-[#C9A44C]/30 text-[#F6F0E6] hover:bg-[#C9A44C]/15 hover:border-[#C9A44C]/60 hover:-translate-y-0.5 transition-all duration-300"
            >
              <span className="text-[#C9A44C] group-hover:text-[#F6E4B0]">{s.icon}</span>
              <span className="text-sm tracking-wide">{s.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialFollow;
export { SOCIALS };
